<template>
    <el-dialog :title="dialogTitle" :visible.sync="showDialog" :close-on-click-modal="false" width="85%" :before-close="dialogHandleClose" center>
        <div v-loading="loading" element-loading-text="数据查询中请稍后" >
            <vxe-form :data="formData" @submit="submitEvent">
                <vxe-form-item v-for="(field, idx) in currentConfig.searchFields" :key="'sf_' + idx" :title="field.title + '：'" :field="field.field" :item-render="{}" span="12">
                    <template #default="{ data }">
                        <vxe-input v-model="data[field.field]" :placeholder="field.placeholder"></vxe-input>
                    </template>
                </vxe-form-item>
            <vxe-form-item align="right" span="24">
                <template #default>
                <vxe-button status="primary" @click="submitEvent">查询</vxe-button>
                <vxe-button type="reset" ref="resetClick">重置</vxe-button>
                </template>
            </vxe-form-item>
            </vxe-form>
            <vxe-table
            :data="tableData"
             empty-text="请输入查询条件，点击查询按钮查询项目信息"
            round
            stripe
            border=inner
            height="430"
            :column-config="{isCurrent: true, isHover: true,resizable: true}"
            :row-config="{isCurrent: true, isHover: true}"
            :scroll-y="{enabled: false}"
            :seq-config="{startIndex: (tablePage.currentPage - 1) * tablePage.pageSize}">
            <vxe-column type="seq" title="序号" align="center" width="80"></vxe-column>
            <vxe-column v-for="col in currentConfig.columns" :key="col.field" :field="col.field" :title="col.title"></vxe-column>
            <vxe-column title="操作" align="center" width="80">
                <template v-slot="{ row }">
                    <vxe-button content="获取" status="primary" @click="getRowDataById(row)" round></vxe-button>
                </template>
            </vxe-column>
            </vxe-table>
            <vxe-pager
                background
                size="small"
                empty-text="未查询到项目信息！"
                :current-page="tablePage.currentPage"
                :page-size="tablePage.pageSize"
                :total="tablePage.totalResult"
                :page-sizes="[10, 20, 100, {label: '大量数据', value: 1000}, {label: '全量数据', value: -1}]"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                @page-change="handlePageChange">
            </vxe-pager>
        </div>
        <!-- 插入测试 -->
        <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose" ref="dialogCloseClick" >关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {queryXtOrderInfo, pageQueryBidProject, pageQueryGuaranteeProject } from '../../../api/comm'

// ========== 模式配置：新增模式只需在此添加配置 ==========
const MODE_CONFIGS = {
    xt: {
        searchFields: [
            { field: 'proName', title: '项目名称', placeholder: '请输入项目名称' },
            { field: 'proCode', title: '项目编号', placeholder: '请输入项目编号' },
            { field: 'bidName', title: '标段名称', placeholder: '请输入标段名称' },
            { field: 'bidCode', title: '标段编号', placeholder: '请输入标段编号' },
        ],
        columns: [
            { field: 'proName', title: '项目名称' },
            { field: 'proCode', title: '项目编号' },
            { field: 'bidName', title: '标段名称' },
            { field: 'bidCode', title: '标段编号' },
            { field: 'tenderAgencyName', title: '代理机构名称' },
            { field: 'tendererName', title: '招标人名称' },
            { field: 'bidOpenDate', title: '开标时间' },
        ],
        apiFn: queryXtOrderInfo,
        formatRequest: (formData) => formData,
        handleResponse: (resp, vm) => {
            vm.list = resp.data
            vm.tablePage.totalResult = resp.data.length
            vm.tableData = vm.list.slice(
                (vm.tablePage.currentPage - 1) * vm.tablePage.pageSize,
                vm.tablePage.currentPage * vm.tablePage.pageSize
            )
        },
        handlePageChange: (vm) => {
            vm.tableData = vm.list.slice(
                (vm.tablePage.currentPage - 1) * vm.tablePage.pageSize,
                vm.tablePage.currentPage * vm.tablePage.pageSize
            )
        },
        mapRow: (row) => row
    },
    standard: {
        searchFields: [
            { field: 'bidName', title: '项目名称', placeholder: '请输入项目名称' },
            { field: 'bidCode', title: '项目编号', placeholder: '请输入项目编号' },
            { field: 'packageName', title: '标段名称', placeholder: '请输入标段名称' },
            { field: 'packageCode', title: '标段编号', placeholder: '请输入标段编号' },
        ],
        columns: [
            { field: 'bidName', title: '项目名称' },
            { field: 'bidCode', title: '项目编号' },
            { field: 'packageName', title: '标段名称' },
            { field: 'packageCode', title: '标段编号' },
            { field: 'agentName', title: '代理机构名称' },
            { field: 'tendereeName', title: '招标人名称' },
            { field: 'bidOpenTime', title: '开标时间' },
        ],
        apiFn: pageQueryGuaranteeProject,
        formatRequest: (formData, tablePage, vm) => {
            // 校验并转换 platCode
            let platCode = vm.platCode
            if (platCode === 'SDPT') {
                platCode = 'SDPT,1007'
            } else if (platCode === '2000') {
                platCode = 'QGPT,2000'
            }
            return {
                bidName: formData.bidName,
                bidCode: formData.bidCode,
                packageName: formData.packageName,
                packageCode: formData.packageCode,
                platCode: platCode,
                current: tablePage.currentPage,
                size: tablePage.pageSize
            }
        },
        handleResponse: (resp, vm) => {
            const page = resp.data
            vm.tableData = page.records || []
            vm.tablePage.totalResult = page.total || 0
            vm.tablePage.currentPage = page.current || 1
            vm.tablePage.pageSize = page.size || 10
        },
        handlePageChange: (vm) => {
            vm.getQueryData()
        },
        mapRow: (row) => ({
            bidName: row.bidName,
            bidCode: row.bidCode,
            tendererName: row.tendereeName,
            bidOpenDate: row.bidOpenTime,
            tenderAgencyName: row.agentName,
            packageName: row.packageName,
            packageCode: row.packageCode,
        })
    }
    // 后续新增模式在此添加，例如：
    // newMode: { searchFields: [...], columns: [...], apiFn: ..., ... }
}

export default {
    name: 'projectdialog',
    props:{
        xtDialogFormVisible:{
            type: Boolean,
            default: false
        },
        dialogTitle:{
            type: String,
            default: '获取邢台项目信息'
        },
        mode:{
            type: String,
            default: 'xt'
        },
        platCode:{
            type: String,
            default: ''
        }
    },
    data () {
        return {
            loading: false,
            requestId: 0,
            pendingRequestId: null,
            formData: this.getInitialFormData(),
            tableData: [],
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0
            },
            list: [],
            showDialog: false
        }
    },
    computed: {
        currentConfig() {
            return MODE_CONFIGS[this.mode] || MODE_CONFIGS.xt
        }
    },
    watch: {
        xtDialogFormVisible(newVal, oldVal) {
          this.showDialog = newVal
          this.cancelPendingQuery()
          if (newVal) {
            this.formData = this.getInitialFormData()
            this.tableData = []
            this.tablePage = {
              currentPage: 1,
              pageSize: 10,
              totalResult: 0
            }
            this.list = []
          }
        }
    },
    methods: {
        // 根据当前模式的 searchFields 动态生成 formData 初始值
        getInitialFormData() {
            const config = MODE_CONFIGS[this.mode] || MODE_CONFIGS.xt
            const data = {}
            config.searchFields.forEach(f => {
                data[f.field] = f.defaultValue !== undefined ? f.defaultValue : ''
            })
            return data
        },
        submitEvent () {
            this.findList()
        },
        findList () {
            this.tablePage.currentPage = 1
            this.getQueryData()
        },
        getQueryData() {
            this.loading = true
            this.requestId += 1
            const currentRequestId = this.requestId
            this.pendingRequestId = currentRequestId
            const config = this.currentConfig
            const params = config.formatRequest(this.formData, this.tablePage, this)
            config.apiFn(params).then((resp) => {
                if (this.pendingRequestId !== currentRequestId) {
                    return
                }
                config.handleResponse(resp, this)
            }).catch(() => {
            }).finally(() => {
                if (this.pendingRequestId === currentRequestId) {
                    this.loading = false
                    this.pendingRequestId = null
                }
            })
        },
        handlePageChange ({ currentPage, pageSize }) {
            this.tablePage.currentPage = currentPage
            this.tablePage.pageSize = pageSize
            this.currentConfig.handlePageChange(this)
        },
        getRowDataById(row) {
            this.$emit('projectInfo', this.currentConfig.mapRow(row))
            this.$refs.dialogCloseClick.$el.click()
        },
        handleClose() {
            this.cancelPendingQuery()
            this.$emit('changeShow','false')
        },
        dialogHandleClose() {
            this.cancelPendingQuery()
            this.$emit('changeShow','false')
        },
        cancelPendingQuery() {
            this.requestId += 1
            this.pendingRequestId = null
            this.loading = false
        }
    }
}
</script>
<style lang="scss" scoped>
</style>